"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import MainLayout from "@/app_views/MainLayout.vue";
import { Component, Vue, Ref } from "vue-property-decorator";
let BindWeiXinSuccess = class extends Vue {
  constructor() {
    super(...arguments);
    this.status = "ready";
    this.message = "";
  }
  created() {
    return __async(this, null, function* () {
      this.message = this.$route.params.message;
    });
  }
};
__decorateClass([
  Ref("selfForm")
], BindWeiXinSuccess.prototype, "_selfForm", 2);
BindWeiXinSuccess = __decorateClass([
  Component({
    components: {
      MainLayout
    }
  })
], BindWeiXinSuccess);
export {
  BindWeiXinSuccess as default
};
